var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgToggleList = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 32,
    viewBox: "0 0 81 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 0.5H78C79.3807 0.5 80.5 1.61929 80.5 3V29C80.5 30.3807 79.3807 31.5 78 31.5H41.5V0.5Z",
    fill: "white",
    stroke: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H42V32H3C1.34315 32 0 30.6569 0 29V3Z",
    fill: "#0078A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12C14.5523 12 15 11.5523 15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11C13 11.5523 13.4477 12 14 12ZM17 16C17 16.5523 17.3731 17 17.8333 17H26.1667C26.6269 17 27 16.5523 27 16C27 15.4477 26.6269 15 26.1667 15H17.8333C17.3731 15 17 15.4477 17 16ZM17 11C17 11.5523 17.3731 12 17.8333 12H26.1667C26.6269 12 27 11.5523 27 11C27 10.4477 26.6269 10 26.1667 10H17.8333C17.3731 10 17 10.4477 17 11ZM17 21C17 21.5523 17.3731 22 17.8333 22H26.1667C26.6269 22 27 21.5523 27 21C27 20.4477 26.6269 20 26.1667 20H17.8333C17.3731 20 17 20.4477 17 21ZM15 16C15 16.5523 14.5523 17 14 17C13.4477 17 13 16.5523 13 16C13 15.4477 13.4477 15 14 15C14.5523 15 15 15.4477 15 16ZM14 22C14.5523 22 15 21.5523 15 21C15 20.4477 14.5523 20 14 20C13.4477 20 13 20.4477 13 21C13 21.5523 13.4477 22 14 22Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.75,
    y: 18.0833,
    width: 5.16667,
    height: 5.16667,
    rx: 1.25,
    stroke: "#333333",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62.084,
    y: 18.0833,
    width: 5.16667,
    height: 5.16667,
    rx: 1.25,
    stroke: "#333333",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.75,
    y: 8.75,
    width: 5.16667,
    height: 5.16667,
    rx: 1.25,
    stroke: "#333333",
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.084,
    y: 8.75,
    width: 5.16667,
    height: 5.16667,
    rx: 1.25,
    stroke: "#333333",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToggleList);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/toggle-list.fe2f28750a8bfe5c653f00f8dd4e0d0e.svg";